import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, ChevronLeftOutline, ChevronRightOutline, IconButton, rem } from '@bonusly/design-system';

import { useSideScroll } from '../../../../../hooks/use-side-scroll';

interface CarouselProps extends PropsWithChildren {
	increment?: number;
}

export const Carousel: FC<CarouselProps> = ({ children, increment }) => {
	const { t } = useTranslation('common');

	const { canScrollLeft, canScrollRight, getButtonProps, getContainerProps } = useSideScroll({ increment });

	return (
		<Box position="relative" display="flex" alignItems="center">
			{canScrollLeft && (
				<IconButton
					icon={<ChevronLeftOutline />}
					aria-label={t('go_back')}
					borderRadius="full"
					color="white"
					backgroundColor="black"
					_hover={{ backgroundColor: 'black' }}
					zIndex={99}
					position="absolute"
					top="50%"
					left="0"
					transform="translateY(-50%)"
					{...getButtonProps('left')}
				/>
			)}

			<Box
				flex={1}
				overflowX="auto"
				display="flex"
				gap={rem(20)}
				scrollbar-width="none"
				{...getContainerProps()}
				css={{
					'&::-webkit-scrollbar': {
						display: 'none',
					},
				}}
			>
				<Box display="flex" gap={rem(12)} flexWrap="nowrap">
					{children}
				</Box>
			</Box>

			{canScrollRight && (
				<IconButton
					icon={<ChevronRightOutline />}
					aria-label={t('next')}
					position="absolute"
					borderRadius="full"
					zIndex={99}
					color="white"
					backgroundColor="black"
					_hover={{ backgroundColor: 'black' }}
					top="50%"
					right="0"
					transform="translateY(-50%)"
					{...getButtonProps('right')}
				/>
			)}
		</Box>
	);
};
